import React, { FC, ReactElement } from 'react';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@column/ui';

interface ReasonTooltipProps {
  children: ReactElement;
  reason?: string;
  side?: 'top' | 'right' | 'bottom' | 'left';
}

// Explains why a control is disabled. Disabled buttons don't fire pointer events, so the tooltip hangs off a wrapper.
export const ReasonTooltip: FC<ReasonTooltipProps> = ({ children, reason, side = 'bottom' }) => {
  if (!reason) {
    return children;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-flex" tabIndex={0}>
            {children}
          </span>
        </TooltipTrigger>
        <TooltipContent side={side} className="max-w-xs">
          {reason}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
